import { Check } from "lucide-react";

export const planKey = (id, interval) => (interval === "year" ? (id === "pro" ? "pro_yearly" : "basic_yearly") : id);

export const money = (n) => (Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`);

export const PriceLine = ({ amount, interval, light, testid }) => (
  <div className="mt-4" data-testid={testid}>
    <p className={`font-display text-5xl font-bold ${light ? "" : "text-navy"}`}>
      {money(interval === "year" ? Math.round((amount / 12) * 100) / 100 : amount)}
      <span className={`text-base font-normal ml-1 ${light ? "text-white/60" : "text-muted-ink"}`}>/mo</span>
    </p>
    <p className={`text-sm mt-1 font-medium ${light ? "text-[#8FD3C6]" : "text-teal"}`}>
      {money(amount)} billed {interval === "year" ? "annually" : "monthly"}
    </p>
  </div>
);

export const BillingToggle = ({ interval, onChange }) => (
  <div className="inline-flex items-center gap-1 rounded-full bg-white border border-line p-1 shadow-sm" role="radiogroup" data-testid="billing-toggle">
    {[["month", "Monthly"], ["year", "Yearly"]].map(([k, label]) => {
      const on = interval === k;
      return (
        <button key={k} type="button" role="radio" aria-checked={on} onClick={() => onChange(k)} data-testid={`billing-${k}-btn`}
          className={`flex items-center gap-2 rounded-full px-5 py-2 text-sm font-medium transition-colors duration-200 ${on ? "bg-navy text-white" : "text-navy hover:bg-paper"}`}>
          {on && <Check size={15} className="text-[#8FD3C6]" />}
          {label}
          {k === "year" && <span className={`text-[11px] rounded-full px-2 py-0.5 font-semibold ${on ? "bg-[#8FD3C6] text-navy" : "bg-teal-soft text-teal"}`} data-testid="save-10-badge">Save 10%</span>}
        </button>
      );
    })}
  </div>
);
